import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import {
  CreateAssessmentRule,
  UpdateAssessmentRule,
} from '../models/assessment-rule.model';

@Injectable({
  providedIn: 'root',
})
export class AssessmentRuleService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(
    pageNumber: number,
    pageSize: number,
    name?: string,
    assessmentId?: string
  ) {
    let params = '';

    if (name) params += `&name=${name}`;
    if (assessmentId) params += `&assessmentId=${assessmentId}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/assessment-rules?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/assessment-rules/' + id
    );
  }

  create(data: CreateAssessmentRule) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/assessment-rules',
      data
    );
  }

  update(id: string, data: UpdateAssessmentRule) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/assessment-rules/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/assessment-rules/${id}/status`,
      { isActive }
    );
  }
}
